module.exports = __webpack_public_path__ + "img/followup.cfd2ba2c.svg";